<template>
  <div class="mainStatus">
    <div class="d-flex align-items-center justify-content-start">
      <div v-for="status in transitions" :key="status.id">
        <button @click="changeStatus(status)" class="button" :style="`color:${status.color}; borderColor:${status.color}`">
          {{ status.name }}
        </button>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end">
      <!-- <div>
        <button class="leftButtons">
          <i class="right"> </i>
          <span>3 از 100</span>
          <i class="left"> </i>
        </button>
      </div> -->
      <div @click="goBack">
        <button class="BackButtons">
          <span class="backTitle">بازگشت</span>
          <img src="@/assets/images/teamtask/back-logo.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    transitions: {
      type: Array,
    },
  },
  methods: {
    goBack() {
      window.history.go(-1)
    },
    changeStatus(status) {
      this.$emit('updateStatus', status)
    },
  },
  computed: {
    taskId() {
      return this.$route.params.id
    },
  },
}
</script>

<style lang="scss" scoped>
.mainStatus {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 65px;
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(104, 104, 104, 0.2);
  border-radius: 5px;
}
.flexStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  text-transform: uppercase;
  color: #444444;
}
.button {
  margin-right: 10px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: bold;
  background: white;
  background-color: white;
  border: 1px solid;
  border-radius: 5px;
}
.button:hover {
  background: white;
  transform: scale(1.02);
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
}
.BackButtons {
  padding: 5px 10px;
  margin-right: 10px;
  white-space: nowrap;
  color: white;
  font-size: 13px;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.leftButtons {
  padding: 5px 10px;
  margin-right: 10px;
  white-space: nowrap;
  color: #556ee6;
  font-size: 13px;
  background: white;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.backTitle {
  margin-left: 4px;
}
i {
  border: solid #556ee6;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.right {
  transform: rotate(-45deg);
  margin-left: 6px;
}
.left {
  transform: rotate(135deg);
  margin-right: 6px;
}
</style>
